import React from 'react';
import { Link } from 'react-router-dom';

const PersonaDropdown = ({ personas }) => {
  // Group personas into chunks of 5 for 3 columns (15 personas / 3 = 5 per column)
  const itemsPerColumn = Math.ceil(personas.length / 3);
  const columns = [];
  
  for (let i = 0; i < 3; i++) {
    const start = i * itemsPerColumn;
    const end = start + itemsPerColumn;
    columns.push(personas.slice(start, end));
  }

  return (
    <div className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-[600px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
      <div className="p-6">
        <div className="grid grid-cols-3 gap-6">
          {columns.map((column, columnIndex) => (
            <div key={columnIndex} className="space-y-2">
              {column.map((persona) => (
                <Link
                  key={persona.name || persona}
                  to={`/browse?persona=${persona.name || persona}`}
                  className="group flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600 rounded-md transition-colors"
                >
                  <div 
                    className={`w-3 h-3 rounded-full mr-3 ${persona.color || 'bg-gray-400'} group-hover:scale-110 transition-transform flex-shrink-0`}
                  ></div>
                  <span className="text-sm font-medium leading-tight">
                    {persona.display_name || persona.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  </span>
                </Link>
              ))}
            </div>
          ))}
        </div>
        
        {/* Footer */}
        <div className="border-t border-gray-100 mt-6 pt-4">
          <Link
            to="/browse"
            className="block text-center px-4 py-3 text-sm font-medium text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
          >
            🚀 Browse All Accelerators
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PersonaDropdown;